import React from 'react';
import { connect } from "react-redux";
import $ from "jquery";
import {FormattedMessage} from "react-intl";

import { setCameFromPage, toggleSelectionWindow, toggleBathroomVisualizerOpen, changeActivePartRelatedItemIndex,
  setQtActiveCategory } from '../../actions/actionFunctions';
import { homePage, getFeatureGroupIconURL } from "../bvComponent/core/assets";

import ActionTypes from "../../misc/actionTypes";
import Analytics from './../../analytics';
import ProjectScopeFunctions from './projectScopeFunctions';

class ProjectScopeSections extends ProjectScopeFunctions {

  componentDidMount() {
    $(window).on(ActionTypes.UPDATE_ALL_ITEMS, this.updateSections);
  }
  componentWillUnmount() {
    $(window).off(ActionTypes.UPDATE_ALL_ITEMS, this.updateSections);
  }

  updateSections = () => {
    this.forceUpdate();
  };

  goToMaterialsPage = (subPart, parentName) => {
    Analytics.sendClickEvent('go-to-materials-' + subPart.partId);
    this.goToMaterialsPageCommon(subPart, parentName)
  };

  checkForWallsComplexGroup = (qtCategory) => {
    return qtCategory.subParts
      .map((subPart, subPartIndex) => {
        const parent = subPart.part.getParent && subPart.part.getParent(); // floor check
        if (parent && parent.partName === "Walls" && parent.subParts().every(wallsSubPart => {
          return qtCategory.subParts.some(qtCatSubPart => qtCatSubPart.part.partId === wallsSubPart.part.partId)
        })) { // here we check - if all walls are included - show just the first one
          if (subPartIndex) {
            return null
          } else {
            subPart.part.homePageTitle = "Walls";
            return subPart
          }
        }
        return subPart
      })
      .filter(subPart => subPart)
  };

  render() {
    const sections = this.getSections();
    return (
      <div className="sections">
        {sections.map((section, index) => {
          return section.items && section.items.length ? (
            <section className="section" key={"section"+index}>
              <h2 className="h2">
                <FormattedMessage id="projectScope.sectionsTitleShopBy" values={{
                  title: section.title
                }}/>
              </h2>
              <ul className="section-list">
                {section.items.map((subPart, index) => {
                  // console.log('subPart.partId', subPart.part.partId);
                  const image = subPart.part.featuredImage || homePage[subPart.part.partId]
                    || subPart.part.customImageUrl || getFeatureGroupIconURL(subPart.part.partName);
                  const isCustom = !homePage[subPart.part.partId] && subPart.part.customImageUrl;
                  const style = {
                    backgroundImage: image ? `url(${image})` : 'none'
                  };
                  if (subPart.part.featuredImage) {
                    style.backgroundSize = "contain";
                  }

                  return (
                    <li className={"section-list__item" + (isCustom ? " section-list__item--custom" : "")} style={style} key={subPart.text+index}
                        onClick={() => this.goToMaterialsPage(subPart.part, section.title)}>
                      <div className="section-list__item-text">
                        {(subPart.part.activeFeature && subPart.part.activeFeature.dbFeature.customGroupName) || subPart.part.homePageTitle || subPart.text}
                      </div>
                    </li>
                  )
                })}
              </ul>
            </section>
          ) : null
        })}
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    layoutParts: store.stepsState.layoutParts,
  };
};

export default connect(mapStateToProps, {
  toggleBathroomVisualizerOpen,
  toggleSelectionWindow,
  setCameFromPage,
  changeActivePartRelatedItemIndex,
  setQtActiveCategory
})(ProjectScopeSections);
